import { SET_SEARCH_SUBMITED } from './actionTypes';

export const setSearchSubmited = (state) => ({
  type: SET_SEARCH_SUBMITED,
  state
})
